import { EventEmitter } from 'events';

export default class FileLoaderStore {
  private _processor: IFileProcessor;
  private _multi: boolean;

  constructor(processor: IFileProcessor & EventEmitter, multi: boolean = false) {
    processor.on('error', console.error);
    this._processor = processor;
    this._multi = multi;
  }

  public fileSelected(e: React.ChangeEvent<HTMLInputElement>) {
    const fileList = e.target.files!;
    let i = 0;
    const files: File[] = [];
    while (fileList.item(i)) {
      const file = fileList.item(i) as File;
      i += 1;
      if (!this._multi) {
        this._processor.process(file);
      } else {
        files.push(file);
      }
    }
    if (this._multi) {
      this._processor.process(files);
    }
    e.target.value = '';
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/stores/FileUploaderStore.ts